module.exports = __webpack_public_path__ + "img/mob4.17b8b31d.png";